module.exports = __webpack_public_path__ + "img/labmemtest_title_kr.a840c43d.png";